module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/snow-1-65ef209d7f2a3e3ace6d5f01e1a484db.svg";